"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPageTitle = exports.setBodyBackgroundColor = void 0;
var _state = require("../state");
const setBodyBackgroundColor = () => {
  const {
    pageBackgroundColor
  } = _state.store.getState().config.values || {};
  document.body.style.backgroundColor = pageBackgroundColor;
};
exports.setBodyBackgroundColor = setBodyBackgroundColor;
const setPageTitle = title => {
  document.title = title;
};
exports.setPageTitle = setPageTitle;